import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { authentication } from '@/modules/authentication/store';
import { checkRole } from '@/modules/authentication/helpers/checkRole';
import authenticationRoutes from '@/modules/authentication/router';
import analysisRoutes from '@/modules/analysis/router';
import homeRoutes from '@/modules/home/router';
import barcodeRoutes from '@/modules/barcode/router';
import nomenclatureRoutes from '@/modules/nomenclature/router';
import resultsRoutes from '@/modules/results/router';
import PageNotFound from '@/components/unique/PageNotFound.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'App',
    redirect: { name: 'LandingPage' }
  },
  ...authenticationRoutes,
  ...homeRoutes,
  ...barcodeRoutes,
  ...analysisRoutes,
  ...nomenclatureRoutes,
  ...resultsRoutes,
  { path: '/404', name: '404', component: PageNotFound },
  { path: '*', redirect: '/404' }
];

const router = new VueRouter({
  routes,
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  if (authentication.state.jwtToken !== null) {
    if (to.matched.some((record) => record.meta.requiredRole)) {
      // If the route contains metadata about access restriction, check user authorization to enter route
      let authorized = true;
      to.matched
        .filter((record) => record.meta?.requiredRole)
        .forEach((record) => {
          if (!checkRole(record.meta.requiredRole)) {
            // The user has not the mandatory role granted.
            authorized = false;
          }
        });
      if (!authorized) {
        // User cannot continue to this route, redirect to homepage.
        next({ name: 'Home' });
      }
    }

    next();
  } else {
    next({ name: '404' });
  }
});

export default router;
